import { catchError, map, Observable, of } from 'rxjs'
import { Injectable, inject } from '@angular/core'
import { HttpClient } from '@angular/common/http'

import { environment } from '@env/environment'

/**
 * ApiCiecStatsService (ADR-0032 · Fase E7).
 *
 * Cliente HTTP del endpoint `GET /ciec-requests/stats?days=N` que devuelve la
 * telemetría de magic links CIEC sistema-wide: cuántas se generaron en el
 * período, distribución por status, conversion rate y tiempo promedio a submit.
 *
 * La pide quien tenga `clients.get-all` (el endpoint no filtra más que eso). En la tarjeta del
 * HomeDashboard, si la API devuelve 403 el campo `stats === null` y la card muestra "—".
 *
 * B-075: la conversión es `byOutcome.received / created` (`conversionRate`, de 0 a 1). Antes se
 * contaba `used`, que incluía enlaces «usados» sin que el SAT validara la CIEC. Las cubetas de
 * `byOutcome` NO son excluyentes: una solicitud con rechazos y un error del proveedor cuenta en ambas.
 */
export interface CiecStats {
  period: { days: number; since: string }
  created: number
  byStatus: { pending: number; used: number; expired: number; cancelled: number; exhausted: number }
  byOutcome: { received: number; rejected: number; exhausted: number; providerError: number; legacyFailed: number }
  conversionRate: number
  averageTimeToSubmitMinutes: number | null
}

@Injectable({ providedIn: 'root' })
export class ApiCiecStatsService {
  private http = inject(HttpClient)

  getStats(days = 30): Observable<CiecStats | null> {
    return this.http.get<{ data: CiecStats }>(`${environment.apiUrl}ciec-requests/stats?days=${days}`).pipe(
      map((r) => (r as any)?.data ?? (r as any)),
      catchError(() => of(null)),
    )
  }
}
